import { ModalContent } from '@/components/Modal'
import { Body } from './Body'
import { Header } from './Header'
import { useConfigureController } from '../hooks/useController'

export function Content() {
  const { ready } = useConfigureController()

  if (!ready) return null

  return (
    <ModalContent header={<Header />}>
      <Body />
    </ModalContent>
  )
}
